/**
 * NAV-5.7 — which Commission skeleton to paint, from a destination id or path.
 *
 * Pure so it can be unit-tested without a DOM. The kinds match the pages that
 * actually exist: the banded Overview (`health`, named for the card it
 * replaced), periods list, remounted list cards, and the Setup rail.
 */
import {
  isCommissionAreaPath,
  isCommissionOverviewPath,
  isCommissionSetupPath,
  type CommissionDestinationId,
} from '@/lib/commissionAreaNav';

export type CommissionSkeletonKind = 'health' | 'table' | 'card' | 'rail';

export function commissionSkeletonKindForDestination(
  id: CommissionDestinationId,
): CommissionSkeletonKind {
  switch (id) {
    case 'overview':
      return 'health';
    case 'periods':
      return 'table';
    case 'setup':
      return 'rail';
    case 'money-held':
    case 'draws':
    case 'guarantees':
    case 'cancelled':
      return 'card';
  }
}

export function commissionSkeletonKindForPath(
  pathname: string,
): CommissionSkeletonKind | null {
  if (!isCommissionAreaPath(pathname)) return null;
  if (isCommissionOverviewPath(pathname)) return 'health';
  if (pathname.startsWith('/app/commission/periods')) return 'table';
  if (isCommissionSetupPath(pathname)) return 'rail';
  return 'card';
}
